import { env } from '@/core/env';

/**
 * Tour Kit Pro (checklists + announcements) shows an "Unlicensed" watermark on
 * non-localhost hosts unless a Polar license key is supplied via
 * `VITE_TOUR_KIT_LICENSE_KEY`. Free packages (orientation tour, hints) never
 * need a key.
 *
 * Localhost / `*.local` stay quiet without a key (Tour Kit's own eval mode).
 * Deployed hosts without a key must not mount Pro packages — hiding the badge
 * with CSS would circumvent the license.
 */

export function getTourKitLicenseKey(): string {
  return env.VITE_TOUR_KIT_LICENSE_KEY ?? '';
}

export function getTourKitOrganizationId(): string {
  return env.VITE_TOUR_KIT_ORGANIZATION_ID ?? '';
}

export function isTourKitDevHost(hostname: string): boolean {
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.endsWith('.local')
  );
}

export function shouldMountTourKitPro(options?: {
  hostname?: string;
  licenseKey?: string;
}): boolean {
  const licenseKey = (options?.licenseKey ?? getTourKitLicenseKey()).trim();
  if (licenseKey.length > 0) {
    return true;
  }
  const hostname =
    options?.hostname ??
    (typeof window === 'undefined' ? '' : window.location.hostname);
  return isTourKitDevHost(hostname);
}
